<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:py-6 tw:lg:px-0 tw:mx-auto tw:lg:py-8"
    >
      <div>
        <div class="tw:w-full tw:flex tw:flex-col tw:lg:flex-row tw:lg:items-end tw:justify-center">
          <TrivagoLogo class="tw:h-[24px] tw:lg:mr-4 tw:mb-2 tw:md:mb-0 tw:lg:mb-[2px]" />
          <p class="tw:text-2xl tw:font-bold tw:text-center tw:lg:text-left">{{ $t('tbs_mp_social_proof_header') }}</p>
        </div>
        <p class="tw:text-sm tw:md:text-base tw:lg:text-xl tw:my-2 tw:text-center tw:font-normal">
          {{ $t('tbs_mp_social_proof_text') }}
        </p>
      </div>
      <div class="tw:flex-wrap tw:mt-2 tw:bg-blue-100 tw:border tw:border-blue-600 tw:flex tw:rounded-[20px]">
        <p
          class="social-proof tw:relative tw:font-bold tw:text-xs tw:lg:text-base tw:w-1/4 tw:text-center tw:p-4"
          v-for="(item, index) in data"
          :class="index !== 0 ? 'social-border' : ''"
          :key="item"
          v-html="$t(item)"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import TrivagoLogo from '@/components/icons/TrivagoLogo.svg?component'

const data = ['tbs_mp_social_proof_2', 'tbs_mp_social_proof_3', 'tbs_mp_social_proof_1', 'tbs_mp_social_proof_4']
</script>

<style scoped>
.social-proof :deep(span) {
  font-size: var(--tw-color-2xl);
  @media (max-width: 768px) {
    font-size: var(--tw-color-base);
    line-height: 1.5;
  }
}

.social-border:before {
  color: var(--tw-color-blue-600);
  content: '';
  height: 70%;
  width: 1px;
  display: block;
  position: absolute;
  left: 0;
}

.social-border:nth-child(3):before {
  @media (max-width: 767px) {
    display: none;
  }
}

.social-proof {
  flex: 50% 0 0;
  @media (min-width: 768px) {
    flex: 25% 0 0;
  }
}
</style>
